import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './alert.module.css';
import { Typography } from '@mui/material';
import { useActivePatrolUI } from '../../context/activePatrol/ActivePatrolUIProvider';
import { useActivePatrolLogic } from '../../context/activePatrol/ActivePatrolLogicProvider';
import { getPatrolCompletionInfo } from '../../utils/getPatrolCompletionInfo';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';

function PatrolIncompleteWarning() {
	const { showIncompleteWarningModal, setShowIncompleteWarningModal } =
		useActivePatrolUI();
	const { checklists, generalNotesInfo } = useActivePatrolData();
	const { finalizeExitPatrol, savePatrol } = useActivePatrolLogic();

	const handleClose = () => {
		setShowIncompleteWarningModal(false);
	};
	const handleEndAnyway = () => {
		setShowIncompleteWarningModal(false);
		savePatrol(finalizeExitPatrol);
	};
	const completionInfo = getPatrolCompletionInfo(
		checklists,
		generalNotesInfo,
	);
	return (
		<Dialog
			open={showIncompleteWarningModal}
			onClose={handleClose}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Incomplete patrol
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<>
							{!completionInfo.isGeneralInfoComplete && (
								<Typography color="error">
									General Notes section is incomplete.
								</Typography>
							)}
							{completionInfo.incompleteChecklists.length > 0 && (
								<>
									<Typography color="error">
										Checklists section is incomplete.
									</Typography>
									The following checklists are incomplete:
									{completionInfo.incompleteChecklists.map(
										(
											checklist: PatrolChecklist,
											index: number,
										) => {
											return (
												<div
													key={checklist.ChecklistID}
												>
													<Typography variant="body2">
														{index + 1}. Checklist "
														{checklist.Name}" has
														the following incomplete
														checkpoints:
													</Typography>
													{checklist.Checkpoints.map(
														(checkpoint) => {
															if (
																checkpoint.CompletionStatus ===
																'Incomplete'
															) {
																return (
																	<Typography
																		variant="body2"
																		className={
																			sty.checkpoint
																		}
																		style={{
																			marginLeft:
																				'2rem',
																		}}
																		key={
																			checkpoint.CheckpointID
																		}
																	>
																		{
																			checkpoint.Name
																		}
																	</Typography>
																);
															}
															return null;
														},
													)}
												</div>
											);
										},
									)}
								</>
							)}
						</>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button
					variant="outlined"
					size="medium"
					onClick={handleClose}
					className={sty.action_button}
				>
					Back
				</Button>
				<Button
					variant="contained"
					size="medium"
					onClick={handleEndAnyway}
					className={sty.action_button}
					color="error"
				>
					End anyway
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default PatrolIncompleteWarning;
